"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Picker = _interopRequireDefault(require("./Picker.scss"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PEOPLE = ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '😇', '🤣', '☺️', '😊', '🙂', '🙃', '😉', '😌', '😍', '😘', '😗', '😙', '😚', '😋', '😜', '😝', '😛', '🤑', '🤗', '🤓', '😎', '🤡', '🤠', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '😤', '😠', '😡', '😶', '😐', '😑', '😯', '😦', '😧', '😮', '😲', '😵', '😳', '😱', '😨', '😰', '😢', '😥', '🤤', '😭', '😓', '😪', '😴', '🙄', '🤔', '🤥', '😬', '🤐', '🤢', '🤧', '😷', '🤒', '🤕', '😈', '👿', '👹', '👺', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '👐', '🙌', '👏', '🙏', '🤝', '👍', '👎', '👊', '✊', '🤛', '🤜', '🤞', '✌️', '🤘', '👌', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐', '🖖', '👋', '🤙', '💪', '🖕', '✍️', '🤳', '💅', '🖖', '💄', '💋', '👄', '👅', '👂', '👃', '👣', '👁', '👀', '👗', '👠', '👞', '👟', '👒', '🎩', '🎓', '👑', '⛑', '🎒', '👝', '👛', '👜', '💼', '👓', '🕶', '☂️'];
var ANIMALS = ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐽', '🐸', '🐵', '🙊', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐚', '🐞', '🐜', '🕷', '🕸', '🐢', '🐍', '🦎', '🦂', '🦀', '🦑', '🐙', '🦐', '🐠', '🐟', '🐡', '🐬', '🦈', '🐳', '🐋', '🐊', '🐆', '🐅', '🐃', '🐂', '🐄', '🦌', '🐪', '🐫', '🐘', '🦏', '🦍', '🐎', '🐖', '🐐', '🐏', '🐑', '🐕', '🐩', '🐈', '🐓', '🦃', '🕊', '🐇', '🐁', '🐀', '🐿', '🐾', '🐉', '🐲', '🌵', '🎄', '🌲', '🌳', '🌴', '🌱', '🌿', '☘️', '🍀', '🎍', '🎋', '🍃', '🍂', '🍁', '🍄', '🌾', '💐', '🌷', '🌹', '🥀', '🌻', '🌼', '🌸', '🌺', '🌎', '🌍', '🌏', '🌕', '🌖', '🌔', '🌚', '🌝', '🌞', '🌛', '🌜', '🌙', '💫', '⭐️', '🌟', '✨', '⚡️', '🔥', '💥', '☄️', '☀️', '🌤', '⛅️', '🌥', '🌦', '🌈', '☁️', '🌧', '⛈', '🌩', '🌨', '☃️', '⛄️', '❄️', '🌬', '💨', '🌪', '🌫', '🌊', '💧', '💦', '☔️'];
var FOOD = ['🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🍍', '🥝', '🥑', '🍅', '🍆', '🥒', '🥕', '🌽', '🌶', '🥔', '🍠', '🌰', '🥜', '🍯', '🥐', '🍞', '🥖', '🧀', '🥚', '🍳', '🥓', '🥞', '🍤', '🍗', '🍖', '🍕', '🌭', '🍔', '🍟', '🥙', '🌮', '🌯', '🥗', '🥘', '🍝', '🍜', '🍲', '🍥', '🍣', '🍱', '🍛', '🍚', '🍙', '🍘', '🍢', '🍡', '🍧', '🍨', '🍦', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🥛', '🍼', '☕️', '🍵', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃', '🍸', '🍹', '🍾', '🥄', '🍴', '🍽', '⚽️', '🏀', '🏈', '⚾️', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸', '🥅', '🏒', '🏑', '🏏', '⛳️', '🏹', '🎣', '🥊', '🥋', '⛸', '🎿', '⛷', '🏂', '🏋', '🤺', '⛹️', '🏌', '🏄', '🏊', '🤽', '🚣', '🏇', '🚴', '🚵', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🎻', '🎲', '🎯', '🎳', '🎮', '🏳', '🏴', '🏁', '🚩', '🎽', '🥇', '🥈', '🥉', '🏆'];
var TRAVEL = ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎', '🚓', '🚑', '🚒', '🚐', '🚚', '🚛', '🚜', '🛴', '🚲', '🛵', '🏍', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '🚁', '🛩', '✈️', '🛫', '🛬', '🚀', '🛰', '💺', '🛶', '⛵️', '🛥', '🚤', '🛳', '⛴', '🚢', '⚓️', '🚧', '⛽️', '🚏', '🚦', '🚥', '🗺', '🗿', '🗽', '⛲️', '🗼', '🏰', '🏯', '🏟', '🎡', '🎢', '🎠', '⛱', '🏖', '🏝', '⛰', '🏔', '🗻', '🌋', '🏜', '🏕', '⛺️', '🛤', '🛣', '🏗', '🏭', '🏠', '🏡', '🏘', '🏚', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛', '⛪️', '🕌', '🕍', '🕋', '⛩', '🗾', '🎑', '🏞', '🌅', '🌄', '🌠', '🎇', '🎆', '🌇', '🌆', '🏙', '🌃', '🌌', '🌉', '🌁', '🎭', '🎨'];
var OBJECTS = ['🆓', '📗', '📕', '⌚️', '📱', '📲', '💻', '⌨️', '🖥', '🖨', '🖱', '🖲', '🕹', '🗜', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽', '🎞', '📞', '☎️', '📟', '📠', '📺', '📻', '🎙', '🎚', '🎛', '⏱', '⏲', '⏰', '🕰', '⌛️', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯', '🗑', '🛢', '💸', '💵', '💴', '💶', '💷', '💰', '💳', '💎', '⚖️', '🔧', '🔨', '⚒', '⛏', '⚙️', '💣', '🔪', '🗡', '⚔️', '🛡', '🚬', '⚰️', '⚱️', '🏺', '🔮', '📿', '💈', '⚗️', '🔭', '🔬', '🕳', '💊', '💉', '🌡', '🚽', '🚰', '🚿', '🛁', '🛀', '🛎', '🔑', '🗝', '🚪', '🛋', '🛏', '🖼', '🛍', '🛒', '🎁', '🎈', '🎏', '🎀', '🎊', '🎉', '🎎', '🏮', '🎐', '✉️', '📪', '📮', '📯', '📜', '📃', '📄', '📑', '📊', '📈', '📉', '🗒', '🗓', '📆', '📅', '📇', '🗃', '🗳', '🗄', '📋', '🗞', '📰', '📘', '📚', '📖', '🔖', '🔗', '📎', '📐', '📏', '📍', '📌', '🖊', '🖌', '🖍', '📝', '✏️', '🔍', '🔓'];
var SYMBOLS = ['❤️', '💛', '💚', '💙', '💜', '🖤', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈️', '♉️', '♊️', '♋️', '♌️', '♍️', '♎️', '♏️', '♐️', '♑️', '♒️', '♓️', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳', '🈶', '🈚', '🈸', '🈺', '🈷', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹', '🈲', '❌', '⭕️', '🛑', '⛔️', '📛', '🚫', '💯', '💢', '♨️', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭', '❕', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️', '⚠️', '🚸', '🔱', '⚜️', '🔰', '♻️', '✅', '🈯', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️', '🌀', '💤', '🚺', '🚼', '🎵', '🎶', '➕', '➖', '➗', '✖️', '💲', '💱', '™️', '©️', '®️', '〰️', '➰', '➿', '🔚', '🔙', '🔛', '🔝', '✔️', '☑️', '🔈', '🔇', '🔉', '🔊', '🔔', '🔕', '📣', '📢', '🗨', '💬', '💭', '🗯', '♠️', '♣️', '♥️', '♦️', '🃏', '🎴', '🀄'];
var CATEGORIES = {
  PEOPLE: 'PEOPLE',
  ANIMALS: 'ANIMALS',
  FOOD: 'FOOD',
  TRAVEL: 'TRAVEL',
  OBJECTS: 'OBJECTS',
  SYMBOLS: 'SYMBOLS'
};

var EmojiPicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(EmojiPicker, _Component);

  var _super = _createSuper(EmojiPicker);

  function EmojiPicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, EmojiPicker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleEmojis", function (emoji) {
      switch (emoji) {
        case CATEGORIES.PEOPLE:
          _this.setState({
            currentEmojis: PEOPLE,
            category: CATEGORIES.PEOPLE
          });

          break;

        case CATEGORIES.ANIMALS:
          _this.setState({
            currentEmojis: ANIMALS,
            category: CATEGORIES.ANIMALS
          });

          break;

        case CATEGORIES.FOOD:
          _this.setState({
            currentEmojis: FOOD,
            category: CATEGORIES.FOOD
          });

          break;

        case CATEGORIES.TRAVEL:
          _this.setState({
            currentEmojis: TRAVEL,
            category: CATEGORIES.TRAVEL
          });

          break;

        case CATEGORIES.OBJECTS:
          _this.setState({
            currentEmojis: OBJECTS,
            category: CATEGORIES.OBJECTS
          });

          break;

        case CATEGORIES.SYMBOLS:
          _this.setState({
            currentEmojis: SYMBOLS,
            category: CATEGORIES.SYMBOLS
          });

          break;

        default:
          _this.setState({
            currentEmojis: PEOPLE,
            category: CATEGORIES.PEOPLE
          });

      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChoose", function (emoji) {
      _this.props.onEmojiSelected(emoji);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderTabs", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].tabs
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.PEOPLE ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.PEOPLE);
        }
      }, '😀'), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.ANIMALS ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.ANIMALS);
        }
      }, '🐶'), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.FOOD ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.FOOD);
        }
      }, '🍎'), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.TRAVEL ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.TRAVEL);
        }
      }, '🚗'), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.OBJECTS ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.OBJECTS);
        }
      }, '🖥'), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].title,
        style: _this.state.category === CATEGORIES.SYMBOLS ? {
          color: 'rgba(0,0,0,1)'
        } : {
          color: 'rgba(0,0,0,0.2)'
        },
        onClick: function onClick() {
          _this.toggleEmojis(CATEGORIES.SYMBOLS);
        }
      }, '❤️'));
    });
    _this.state = {
      currentEmojis: PEOPLE,
      category: CATEGORIES.PEOPLE
    };
    return _this;
  }

  (0, _createClass2["default"])(EmojiPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].emojiPickerWrapper
      }, this.renderTabs(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Picker["default"].emojiWrapper
      }, this.state.currentEmojis.map(function (emoji, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _Picker["default"].emoji,
          key: "emoji_".concat(index),
          onClick: function onClick() {
            return _this2.onChoose(emoji);
          }
        }, emoji);
      }))), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _Picker["default"].closeButton,
        name: "chevron-up",
        onClick: this.props.closeFn
      }));
    }
  }]);
  return EmojiPicker;
}(_react.Component);

EmojiPicker.propTypes = {
  onEmojiSelected: _propTypes["default"].func,
  closeFn: _propTypes["default"].func
};
var _default = EmojiPicker;
exports["default"] = _default;